import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './OrderItemThumbnail.css';
import Lightbox from '../Lightbox/Lightbox';
import { getItemImageUrl } from '../../../helpers/itemImageUrl';
import DefaultImage from '../../../../public/StoreIcon/defaultFood.svg';

// Falls back medium_ variant -> original file -> placeholder, once each.
class OrderItemThumbnail extends Component {
  static propTypes = {
    image: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    image: null,
    name: '',
    className: '',
  };

  state = {
    stage: 'medium',
    lightboxOpen: false,
  };

  componentDidMount() {
    // An SSR-rendered <img> can fail before hydration, so onError never fires.
    if (this.img?.complete && this.img.naturalWidth === 0) {
      this.handleError();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.image !== this.props.image) {
      this.setState({ stage: 'medium', lightboxOpen: false });
    }
  }

  handleError = () => {
    const { image } = this.props;
    this.setState(({ stage }) => {
      const hasOriginalFallback = stage === 'medium'
        && getItemImageUrl(image, 'original') !== getItemImageUrl(image, 'medium');
      return { stage: hasOriginalFallback ? 'original' : 'placeholder' };
    });
  };

  openLightbox = () => this.setState({ lightboxOpen: true });

  closeLightbox = () => this.setState({ lightboxOpen: false });

  render() {
    const { image, name, className } = this.props;
    const { stage, lightboxOpen } = this.state;
    const isPlaceholder = !image || stage === 'placeholder';

    const img = (
      <img
        ref={(el) => { this.img = el; }}
        src={isPlaceholder ? DefaultImage : getItemImageUrl(image, stage)}
        alt={name}
        loading="lazy"
        className={cx(s.image, { [s.placeholderImage]: isPlaceholder })}
        onError={isPlaceholder ? undefined : this.handleError}
      />
    );

    if (isPlaceholder) {
      return <span className={cx(s.thumb, 'd-print-none', className)}>{img}</span>;
    }

    return (
      <>
        <button
          type="button"
          className={cx(s.thumb, s.button, 'd-print-none', className)}
          onClick={this.openLightbox}
          aria-label={name}
        >
          {img}
        </button>
        <Lightbox
          isOpen={lightboxOpen}
          onClose={this.closeLightbox}
          imageSrc={getItemImageUrl(image, 'original')}
          altText={name}
        />
      </>
    );
  }
}

export default withStyles(s)(OrderItemThumbnail);
